import { CollectionListClass, TrendingCollectionListClass } from "../utils/HelperClass/CommonClass";
import AxiosService from "./AxiosService";

class ApiService {
  private static QuickNodeUrl =
    "https://lively-floral-bird.solana-mainnet.discover.quiknode.pro/";
  private static QuickNodeApiSecret =
    "46c14da591a3c89da93cd028aa82fa09e5c67f0d/";
  private static QuickNodeFullApiUrl =
    this.QuickNodeUrl + this.QuickNodeApiSecret;
  private static SolanaArtUrl = "https://api-v2.solanart.io/"

  public static async GetNftByWalletAddress(walletAddress, page, pageSize) {
    var payload = JSON.stringify({
      method: "qn_fetchNFTs",
      params: {
        wallet: walletAddress,
        omitFields: ["provenance", "creators", "traits"],
        page: page,
        perPage: pageSize,
      },
    });
    return await AxiosService.post(this.QuickNodeFullApiUrl, payload);
  }

  public  static async GetTrendingNFTCollection(limit = 10, period = '24h'){

    const endpoint = "collections/top"
    const queryParms = `?period=${period}&limit=${limit}`;
    const result = await AxiosService.get(this.SolanaArtUrl + endpoint + queryParms);

    const finalResult : TrendingCollectionListClass[] = [];
    result.data.forEach(element => {
      finalResult.push({
        imageUrl: element.logo,
        name: element.name,
        description: element.description,
        price:"",
        collectionUrl: element.url,
        floorPrice: element.floorPrice,
        supply: element.supply,
        totalVolume: element?.volume?.totalVolume || 0
      })
    });

    return finalResult;
  }

  public  static async GetNFTCollectionDetails(collection_id, limit = 50){

    const endpoint = "nfts"
    const queryParms = `?collection_id=${collection_id}&limit=${limit}`;
    const result = await AxiosService.get(this.SolanaArtUrl + endpoint + queryParms);
    
    const finalResult : CollectionListClass[] = [];

      result.data?.items.forEach(element => {
        finalResult.push({
          imageUrl: element.image,
          name: element.name,
          description: element.description,
          tokenAddress : element.tokenAddress,
          price: element.price,
          collectionUrl: element.collectionUrl,
          network : "mainnet-beta",
          chain : "SOL"
        })
      });
      
    return finalResult;
  }
}

export default ApiService;
